export const SET_PRICING = 'SET_PRICING'

export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'

export const CLEAR_LIST_NOTIFICATIONS = 'CLEAR_LIST_NOTIFICATIONS'

export const DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS'
